import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M9.75 5.25a.75.75 0 1 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Zm0 6a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75ZM9 18a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 18Zm-2.665-7.21a.3.3 0 0 0 .286.21h.409a.3.3 0 0 0 .285-.392l-1.607-5a.3.3 0 0 0-.285-.208h-.928a.3.3 0 0 0-.286.212l-1.53 5a.3.3 0 0 0 .288.388h.385a.3.3 0 0 0 .288-.217l.299-1.038a.3.3 0 0 1 .288-.217h1.49a.3.3 0 0 1 .287.21l.331 1.052ZM4.668 7.131c.08-.292.494-.293.577-.001l.344 1.208a.3.3 0 0 1-.289.382h-.68a.3.3 0 0 1-.289-.38l.337-1.209Zm2.455 10.101c0-.76-.592-1.056-1-1.136.384-.096.824-.36.824-.952v-.352c0-.888-.784-1.392-1.984-1.392H3.535a.3.3 0 0 0-.3.3v5a.3.3 0 0 0 .3.3h1.42c1.328 0 2.168-.6 2.168-1.448v-.32Zm-2.58-3.096h.428c.592 0 .96.224.96.712v.296c0 .456-.32.68-.808.68h-.58a.3.3 0 0 1-.3-.3v-1.088a.3.3 0 0 1 .3-.3Zm1.572 3.08v.288c0 .504-.432.76-1.144.76h-.428a.3.3 0 0 1-.3-.3v-1.128a.3.3 0 0 1 .3-.3h.628c.616 0 .944.256.944.68Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextListUppercaseAlphabetIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textListUppercaseAlphabet')) as IconWithRender;

TextListUppercaseAlphabetIcon.displayName = 'TextListUppercaseAlphabetIcon';
TextListUppercaseAlphabetIcon.propTypes = Icon.propTypes;
TextListUppercaseAlphabetIcon.renderIcon = (props) => (
  <TextListUppercaseAlphabetIcon {...props} />
);
export default TextListUppercaseAlphabetIcon;
